import src from "IMAGE";
export default { src, width: 1320, height: 1, blurWidth: 0, blurHeight: 0};
